import { render, staticRenderFns } from "./noDataTable.vue?vue&type=template&id=7b80af96&scoped=true"
import script from "./noDataTable.vue?vue&type=script&lang=js"
export * from "./noDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80af96",
  null
  
)

export default component.exports